import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import AnalyticsStackFeatures from "./AnalyticsStackFeatures";
import AnalyticsStackBenefits from "./AnalyticsStackBenefits";

// AnalyticsStack Component
export default function AnalyticsStack() {
  // Key analytics features
  const data1 = [
    "Farming Analytics: Provides real-time data on farm assets and site performance, optimizing farm operations and resource management.",
    "Processing Analytics: Offers insights into machinery assets, product statuses, and processing unit performance for efficient production management.",
    "IoB Server: Stores real-time IoT device data in a database and publishes it to a Socket.IO server for further analysis and processing.",
  ];

  // Additional system components
  const data2 = [
    "EAM: Retrieves weather information by querying an external weather API based on location parameters.",
    "IAM: Validates access tokens, ensuring secure and authorized access to resources based on defined policies and permissions.",
    "DB: Stores configurations, device metadata, topics, and commands, acting as a central repository for managing crucial system information.",
  ];

  return (
    <>
      {/* Display Analytics Stack title and description */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Analytics Stack"]}
        bannerbodycopy="Farming Analytics | Processing Analytics"
      />

      {/* Provide an overview of the Analytics Stack ecosystem */}
      <SolutionEcosystem title="Overview" type="AnalyticsStack" />

      {/* Display key analytics features */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Feature details */}
      <AnalyticsStackFeatures />

      {/* Benefits of integrating analytics */}
      <AnalyticsStackBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          href4="http://54.185.221.117:8901/v2/api-docs/"
          heading="Do you want to develop applications or integrate your legacy hardware and software?"
        />
      </Container>
    </>
  );
}

